import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './Profile.css';
import logo2 from "../assets/ctrlfour.png";
import { getMatchData } from '../api/riotApi';
import { updateMatchData } from '../api/riotApi';
import { getSearchMore } from '../api/riotApi';

function Profile() {
  const { summonerName } = useParams();
  const navigate = useNavigate();

  const [query, setQuery] = useState(summonerName);
  const [result, setResult] = useState(null);
  const [matchList, setMatchList] = useState([]);
  const [offset, setOffset] = useState(0);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [error, setError] = useState(null);
  const [canRefresh, setCanRefresh] = useState(false);

  const parseUserInfo = (raw) => {
    if (!raw.includes('#')) {
      return { nm_user: raw.trim(), tag_user: 'KR1' };
    }
    const parts = raw.split('#');
    if (parts.length === 2) {
      return { nm_user: parts[0].trim(), tag_user: parts[1].trim() };
    }
    return null;
  };

  useEffect(() => {
    if (!summonerName) return;
    const parsed = parseUserInfo(summonerName);
    if (!parsed) {
      setError('ID#tag 형태로 올바른 소환사 정보를 입력해주세요.');
      setLoading(false);
      return;
    }
    setQuery(summonerName);
    setOffset(0);
    setMatchList([]);
    setLoading(true);
    fetchData(parsed, 0, true);
  }, [summonerName]);

  const fetchData = async (userInfo, off, isInitial = false, lastStTime = null, apiFunc = getMatchData) => {
    try {
      if (!isInitial) setLoadingMore(true);
      const res = await apiFunc(userInfo, off, lastStTime);
      setMatchList(prev => [...prev, ...res.data.matchGameList]);
      setResult(res.data.userInfo);
    } catch (err) {
      console.error('API 호출 실패:', err);
      //setError('소환사 정보를 불러올 수 없습니다.');
      setMatchList([]);
      setResult(null);
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  };

  const handleLoadMore = async () => {
    const nextOffset = offset + 1;
    setOffset(nextOffset);

    const lastMatch = matchList[matchList.length - 1];
    const lastStTime = lastMatch?.dt_st_game || null;
    const nm_user = result?.nm_user || null;
    const tag_user = result?.tag_user || null;
    const puuid = result?.puuid || null;

    const parsed = {
        lastStTime,
        nm_user,
        tag_user,
        puuid
    };

    await fetchData(parsed, nextOffset, false, lastStTime, getSearchMore);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    const parsed = parseUserInfo(query);
    if (!parsed) {
      alert('ID#tag 형태로 올바른 소환사 정보를 입력해주세요.');
      return;
    }
    navigate(`/profile/${encodeURIComponent(query.trim())}`);
  };

    const handleSummonerClick = (nm_user, tag_user) => {
      setQuery(`${nm_user}#${tag_user}`); // 선택한 소환사 이름 표시용
      setOffset(0);
      setMatchList([]);
      setLoading(true);
      fetchData({ nm_user, tag_user }, 0, true);
    };

    function formatRelativeTime(isoTimeStr) {
      const now = new Date();
      const date = new Date(isoTimeStr);
      const diffMs = now - date;

      if (isNaN(date)) return ''; // 유효하지 않은 날짜 처리

      const minute = 60 * 1000;
      const hour = 60 * minute;
      const day = 24 * hour;
      const week = 7 * day;
      const month = 30 * day;
      const year = 365 * day;

      if (diffMs < minute) return '방금 전';
      if (diffMs < hour) return `${Math.floor(diffMs / minute)}분 전`;
      if (diffMs < day) return `${Math.floor(diffMs / hour)}시간 전`;
      if (diffMs < week) return `${Math.floor(diffMs / day)}일 전`;
      if (diffMs < month * 6) return `${Math.floor(diffMs / week)}주 전`;
      if (diffMs < year) return `${Math.floor(diffMs / month)}달 전`;

      return '오래 전';
    };

    function formatMinuteSecondDiff(st, end) {
      const startTime = new Date(st);
      const endTime = new Date(end);

      if (isNaN(startTime) || isNaN(endTime)) return '';

      const diffMs = endTime - startTime;
      if (diffMs < 0) return '';

      const totalSeconds = Math.floor(diffMs / 1000);
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;

      return `${minutes}분 ${seconds}초`;
    }

    useEffect(() => {
      if (!result?.time_str_last_load) return;
      setCanRefresh(result.time_str_last_load !== "방금전");
    }, [result]);

  if (loading && offset === 0) return <div>로딩 중...</div>;

  return (
    <div className="profile-container">
      <div className="profile-search">
        <div className="search-box">
          <div className="profile-logo-box">
            <img src={logo2} alt="ctrl4.gg" height={100} width={200} />
          </div>
          <form onSubmit={handleSearch} className="search-form">
            <input
              type="text"
              name="userId"
              placeholder="소환사이름#태그"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
            <button type="submit">검색</button>
          </form>
          {error && <p className="error-msg" style={{ color: 'red' }}>{error}</p>}
        </div>
      </div>

      {!result ? (
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          소환사 아이디 및 태그를 확인하세요.
        </div>
      ) : (
        <>
        <div className="basic-info">
          <h1>{`${result.nm_user}#${result.tag_user}`}</h1>
          <p>레벨: {result.level}</p>
          <p>{result.region}</p>
          <p style={{ display: 'inline-block', marginRight: '10px' }}>{result.time_str_last_load}</p>
          <button
            onClick={async () => {
                const puuid = result.puuid;
                const endTime = matchList.length > 0 ? matchList[0].dt_end_game : null;

                try {
                  await updateMatchData(puuid, endTime);
                  alert('매치 데이터가 업데이트되었습니다.');

                  // 조회된 result 기준으로 fetchData 다시 호출
                  const userInfo = {
                    nm_user: result.nm_user,
                    tag_user: result.tag_user,
                  };
                  setMatchList([]);
                  setOffset(0);
                  await fetchData(userInfo, 0, true);

                } catch (e) {
                  console.error('업데이트 실패:', e);
                  alert('업데이트 중 오류가 발생했습니다.');
                }
            }}
            className="renewal-btn"
            disabled={!canRefresh}
          >
            갱신하기
          </button>
        </div>

      <div className="match-history">
        <h2>최근 게임</h2>
        <div className="match-cards">
          {matchList.length > 0 ? (
            <>
              {matchList.map((match, index) => (
                <div key={index}  className={`match-card ${match.gameDetailList[0].win === "Y" ? "win" : "lose"}`}>
                  <div className="match-card-info">
                    <h2>{match.md_game}</h2>
                    <p>{formatRelativeTime(match.dt_end_game)}</p>
                    <hr style={{ borderTop: '2px solid #999', margin: '1rem 0', width: '100%' }} />
                    <h2>{match.gameDetailList[0].win === "Y" ? "승리" : "패배"}</h2>
                    <p>{formatMinuteSecondDiff(match.dt_st_game, match.dt_end_game)}</p>
                  </div>
                  <div className="match-card-result">
                    <div className="match-card-play">
                      <img
                        src={`https://ddragon.leagueoflegends.com/cdn/15.11.1/img/champion/${match.gameDetailList[0].nm_champ}.png`}
                        alt={match.gameDetailList[0].nm_champ}
                        width="64"
                        height="64"
                      />
                      <p>
                        {match.gameDetailList[0].kills} / {match.gameDetailList[0].deaths} / {match.gameDetailList[0].assists}
                      </p>
                    </div>

                    <div className="match-card-item">
                      <div style={{ display: 'flex', gap: '5px', marginTop: '10px' }}>
                        {Array.from({ length: 6 }, (_, i) => {
                          const itemId = match.gameDetailList[0][`item${i}`];
                          return itemId ? (
                            <img
                              key={`item-${i}`}
                              src={`https://ddragon.leagueoflegends.com/cdn/15.11.1/img/item/${itemId}.png`}
                              alt={`item-${itemId}`}
                              width="42"
                              height="42"
                            />
                          ) : null;
                        })}
                      </div>
                    </div>
                  </div>

                    <div className="match-card-team">
                      <div className="team team-1">
                        {match.gameDetailList.slice(0, 5).map((player, i) => (
                          <div key={`team1-${i}`} style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '4px' }}>
                            <img
                              src={`https://ddragon.leagueoflegends.com/cdn/15.11.1/img/champion/${player.nm_champ}.png`}
                              alt={player.nm_champ}
                              width="32"
                              height="32"
                              style={{ borderRadius: '4px' }}
                            />
                            <span
                              style={{ fontSize: '0.85rem', cursor: 'pointer' }}
                              onClick={() => handleSummonerClick(player.nm_user, player.tag_user)}
                            >
                              {player.nm_user}
                            </span>
                          </div>
                        ))}
                      </div>
                      <div className="team team-2">
                        {match.gameDetailList.slice(5, 10).map((player, i) => (
                          <div key={`team2-${i}`} style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '4px' }}>
                            <img
                              src={`https://ddragon.leagueoflegends.com/cdn/15.11.1/img/champion/${player.nm_champ}.png`}
                              alt={player.nm_champ}
                              width="32"
                              height="32"
                              style={{ borderRadius: '4px' }}
                            />
                            <span
                              style={{ fontSize: '0.85rem', cursor: 'pointer' }}
                              onClick={() => handleSummonerClick(player.nm_user, player.tag_user)}
                            >
                              {player.nm_user}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                </div>
              ))}

              <div style={{ textAlign: 'center', marginTop: '20px' }}>
                {loadingMore ? <p>로딩 중...</p> : <button onClick={handleLoadMore}>더 보기</button>}
              </div>
            </>
          ) : (
            <p>최근 게임이 없습니다.</p>
          )}
        </div>
      </div>
        </>
      )}
    </div>
  );
}

export default Profile;